var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters.serviceType)?_c('div',{staticClass:"services-container"},[_c('router-view',{key:Math.random()})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }